import {
    ResponsiveContainer,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid,
    Label,
    ComposedChart
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { BarGraphTooltip, filterBarKeysIfNoData, formatGraphAxis, CustomLegend, formatTicker } from '../utils/graph-utils';
import { composedChartMargin, barGraphFontSize, labelOffSet, legendHeight, legendIconSize, responsiveContainerHeight, facilityColors, chartOffset } from '../constants/graph-constants';

const FacilityBarChart = ({ data, facilities, type, group, year, unit }) => {

    const filteredBarKeys = filterBarKeysIfNoData(facilities, data);
    const sortedAndFilteredBarKeys = filteredBarKeys?.slice().sort((a, b) => a.localeCompare(b))

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Typography variant="h6" align="center" gutterBottom>
                {group} {type} {year} per Facility
            </Typography>
            <ResponsiveContainer width="100%" height={responsiveContainerHeight}>
                <ComposedChart data={data} margin={composedChartMargin}>
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis
                        dataKey="month"
                        fontSize={barGraphFontSize}
                    >
                        <Label value="Month" position='insideBottom' offset={labelOffSet} fontSize={barGraphFontSize} />
                    </XAxis>
                    <YAxis
                        fontSize={barGraphFontSize}
                        domain={([dataMin, dataMax]) => { const yAxisDisplayMax = formatGraphAxis(dataMax, dataMin); return yAxisDisplayMax }}
                        tickFormatter={value => formatTicker(value)}
                    >
                        <Label value={unit} angle={-90} position={'insideLeft'} offset={chartOffset} fontSize={barGraphFontSize} />
                    </YAxis>
                    <Tooltip content={<BarGraphTooltip />} />
                    <Legend content={<CustomLegend variant={'facility'} />} iconSize={legendIconSize} verticalAlign='top' height={legendHeight} />
                    {sortedAndFilteredBarKeys?.map(barKey => {
                        return (
                            <Bar
                                key={barKey}
                                dataKey={barKey}
                                fill={facilityColors[barKey] || '#ccc'}
                                name={barKey}
                            />
                        );
                    })}
                </ComposedChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default FacilityBarChart;